import styled, { createGlobalStyle, themes } from '@kawaui/theme'

const theme = themes.default

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'VPIcons';

    src: url('/fonts/veepeeIcons.woff');
  }
    ul {
  list-style: none;
}

a {
  text-decoration: none;
}


  html {
    background-color: ${theme.colors.white.s100};
    box-sizing: border-box;
    font-size: 16px;
  }

  *, *:before, *:after {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
  }

  input:focus,
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px white inset;
    -webkit-box-shadow: 0 0 0px 1000px white inset;
  }

  input::-ms-clear {
    display: none;
  }

  body {
    background-color: ${theme.colors.gray.s200};
    color: ${theme.colors.gray.s700};
    font-family: ${theme.variables.fontFamily.title};
    height: 100%;
    margin: 0;
    min-width: 320px;
    overflow: auto;

    #__next {
      height: 100%;
    }

    .appear-done {
      z-index: 30;

      @media all and (-ms-high-contrast: none) {
        transition-duration: 450ms;

        > div {
          bottom: 0;
          display: block;
          left: 0;
        }
      }
    }
  }
`
